import {createSvgIcon} from "@mui/material";

export const BackIcon = createSvgIcon(
    <svg width="7" height="7" viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M6.4581 11.4205L0.946733 5.90909L6.4581 0.397727L7.62855 1.55682L4.12287 5.0625H12.6399V6.75568H4.12287L7.62855 10.2557L6.4581 11.4205Z" fill="#4C8BF5"/>
    </svg>,
    'BackIcon'
)